export default {
    computed: {

        projectData() {
            return this.$store.state.donation.projectData
        },

        fundraiserData() {
            return this.$store.state.donation.fundraiserData
        },

        donationData() {
            return this.$store.state.donation.donationData
        },

        formSelectChoices() {
            return this.$store.state.donation.formSelectChoices
        },

        projectIsLoaded() {
            return this.$store.state.donation.projectIsLoaded
        },

        donationFinishedSuccessful() {
            return this.$store.state.donation.donationFinishedSuccessful
        },
    },

    methods: {
        /////////////////////////////////////////////////
        //Mutations
        /////////////////////////////////////////////////

        setDonationProp(prop, value, path = null) {
            this.$store.commit('donation/setDonationProp', {prop, value, path})
        },

        setProjectData(project) {
            this.$store.commit('donation/setProjectData', project)
        },

        setFundraiserData(fundraiser) {
            this.$store.commit('donation/setFundraiserData', fundraiser)
        },

        setProjectIsLoaded(loaded) {
            this.$store.commit('donation/setProjectIsLoaded', loaded)
        },

        discardProjectData() {
            this.$store.commit('donation/discardProjectData')
        },

        discardDonationData() {
            this.$store.commit('donation/discardDonationData')
        },

        resetFeeSelection() {
            return this.$store.commit('donation/resetFeeSelection')
        },


        /////////////////////////////////////////////////
        //Actions
        /////////////////////////////////////////////////
        fetchProjectData(projectId, fundraiser) {
            return this.$store.dispatch('donation/fetchProjectData', {projectId, fundraiser})
        },

        sendDonation(fundraiser = null) {
            return this.$store.dispatch('donation/sendDonation', fundraiser)
        },

        fetchDonorInformation(donorHint) {
            return this.$store.dispatch('donation/fetchDonorInformation', donorHint)
        },
    }
}
